let BASE_URL = window.location.origin;
if (window.location.hostname === "localhost") {
  BASE_URL = "http://localhost:3081/";
}

export const AUTH_CONFIG = {
  // PROD tenant in every environment, upload-test included (2026-08). The old
  // test↔prod swap is retired — do NOT put the test tenant back here
  // (login-hub1.skypad.biz / clientId oFPHo4mppjFhnLBgpXb82LCjB1wgvu8R /
  // basicConnection omitted). These three are compiled into the bundle, so
  // whatever is committed ships to both `upload` and `upload-test`.
  domain: "login-hub.skypad.biz",
  clientId: "MRU5JBQ8cYP7RmsZBukTSCg4XK4wWRt9",
  callbackUrl: window.location.origin,
  clientName: "Upload",
  BASE_URL: BASE_URL,
  basicConnection: "LDAP-Connection-GCP",
};
